import(/* webpackMode: "eager", webpackExports: ["FooterProfileLink"] */ "/app/apps/royalur/src/components/layout/FooterProfileLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/royalur/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/backgrounds/home.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/discord.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/reddit.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/logo_text_only.svg");
;
import(/* webpackMode: "eager", webpackExports: ["CookiePreferencesButton"] */ "/app/packages/web_components/src/cookie/CookiePreferencesButton.tsx");
